import { parse } from 'qs';
import { unsubscribe } from '../../actions/unsubscribe';

export default [
  (params, state, match, search) => {
    const { token } = parse(search);

    return unsubscribe(token);
  },
];
